import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ContextCart } from "../../context/Context.Cart";
import { ContextLanguage } from "../../context/Context.Language";
import AddressCreateMyLocation from "../../pages/address/functions/Address.CreateMyLocation";
import { Favorite } from "../../pages/address/render/Address.Search";
import {
  MAX_TEXT_LENGTH,
  TEXT_CANCEL,
  TEXT_CONFIRM,
  TEXT_PLACEHOLDER_ADDRESS_DETAIL,
  TEXT_PLACEHOLDER_ADDRESS_NAME,
  TEXT_PRIMARY,
  TEXT_SEARCH_AGAIN,
  TEXT_TOTAL,
} from "../../utils/useConstants";
import { STATE_CONSTANTS_ADDRESS } from "../../utils/useConstantState";
import {
  STYLE_ADDRESS_FOUND,
  STYLE_ADDRESS_ICON_BLUE_CIRCLE,
  STYLE_BORDER_BLUE_ADDRESS,
  STYLE_BOTTOM_BAR,
  STYLE_BUTTON_BAR_BLUE,
  STYLE_BUTTON_BAR_DISABLE,
  STYLE_HEIGHT_BAR,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_SUB_DETAIL,
  STYLE_TOTAL_BAR_TEXT,
  STYLE_TWOBUTTON_ADDRESS,
} from "../../utils/useStyle";
import { BlueButton, DisableButton, TwoButton } from "../attributes/Button";
import SwitchCeles from "../attributes/SwitchCeles";
import useAutosizeTextArea from "../../utils/useAutosuzeTextArea";
import { ICON_ADDRESS_LOCATION } from "../../utils/useIcons";
import {
  StoreSelectedLocation,
  SystemStoreBasketAddress,
} from "../../utils/useStorage";
import { DeclareState } from "radium-omnibus";
import { useContext } from "react";
import { useIsMobile } from "../../utils/useIsMobile";

const AddressShowLocation = ({
  setTab,
  isStar = false,
  setIsStar = () => {},
  setHistory,
  index,
}) => {
  const lineRef = React.useRef(null);

  const { language } = React.useContext(ContextLanguage);

  const selectedLocation = StoreSelectedLocation(
    (state) => state.selectedLocation
  );

  React.useEffect(() => {
    if (lineRef?.current) {
      lineRef.current.style.width = `${lineRef.current.offsetWidth + 48}px`;
    }
  }, []);

  const { user } = useSelector((state) => state.auth);

  return (
    <div className="py-[14px] px-[14px] md:px-6   <no.10>">
      <div
        // className={`relative flex justify-between items-center p-[14px] md:pr-[4px] gap-[14px] md:gap-3.5 md:py-0 `}
        className={`${
          selectedLocation?.isAvailable ? "" : ""
        } relative flex justify-between md:pr-[4px]   c4`}
      >
        <div
          onClick={() => {
            // if (setHistory) {
            //   RouterGetHistory(setHistory, STATE_CONSTANTS_ADDRESS.SELECT);
            // }
            if (setTab) {
              setTab(STATE_CONSTANTS_ADDRESS.FOUND);
            }
          }}
          className={STYLE_ADDRESS_FOUND}
        >
          <div className={STYLE_ADDRESS_ICON_BLUE_CIRCLE}>
            <ICON_ADDRESS_LOCATION className={` w-4 h-4 text-white`} />
          </div>

          <div
            className={` text-laudry-gray-200 font-semibold leading-6 ${
              language === "TH"
                ? " text-xs-th  md:text-base-th "
                : " text-sm md:text-base "
            } `}
          >
            <span className="line-clamp-1">{selectedLocation?.name}</span>

            <div className={STYLE_SUB_DETAIL(language) + ` line-clamp-2 `}>
              {selectedLocation?.address_components?.map((item, index) => {
                if (item?.types?.includes("plus_code")) {
                  return "";
                } else if (index > 1) {
                  return `, ${item.long_name}`;
                } else if (index === 1) {
                  return `${item.long_name}`;
                } else {
                  return `${item?.long_name}, `;
                }
              })}
            </div>
          </div>
        </div>
        {user?._id && setIsStar && (
          <Favorite setIsStar={setIsStar} isStar={isStar} setTab={setTab} />
        )}
        {index > 0 && (
          <div
            ref={lineRef}
            className="absolute -left-6 border-b border-gray-200  w-full "
          />
        )}
      </div>
    </div>
  );
};

export const Total = ({ price = 0 }) => {
  const { language } = React.useContext(ContextLanguage);
  return (
    <div className={STYLE_TOTAL_BAR_TEXT(language)}>
      <div>{TEXT_TOTAL[language]}</div>
      <div>฿{price}</div>
    </div>
  );
};
export const AddressMarker = ({ isStar, setIsStar = false }) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <div
      // className={`bg-laudry-graycard w-full rounded-lg md:p-6 h-[74px] md:h-24 grid my-3 md:my-4 `}
      className="bg-laudry-graycard my-3 md:my-4 rounded-lg"
    >
      <AddressShowLocation
        className={` flex justify-between ${user ? "  " : ""}`}
        isStar={isStar}
        setIsStar={setIsStar}
      />
    </div>
  );
};

export const BottomBar = ({
  title,
  onClick,
  Calculate,
  icon,
  disable,
  onClickDisable,
  Submit,
  titlefirst,
  titlesecond,
  onSubmit,
  bottompadding = "",
  classNameBottomBar = "",
}) => {
  const { language } = useContext(ContextLanguage);

  return (
    <div className={`${bottompadding} w-full bg-white`}>
      <div
        className={`${classNameBottomBar}  ${STYLE_BOTTOM_BAR} ${STYLE_MAX_WIDTH_DESKTOP}`}
      >
        {Calculate ? <Total /> : ""}
        {disable ? (
          <DisableButton
            title={title}
            onClick={onClickDisable}
            icon={icon}
            className={`${STYLE_BUTTON_BAR_DISABLE(language)}`}
          />
        ) : (
          <BlueButton
            title={title}
            onClick={onClick}
            onSubmit={onSubmit}
            icon={icon}
            className={`${STYLE_BUTTON_BAR_BLUE(language)} `}
          />
        )}
        {Submit ? (
          <TwoButton titlefirst={titlefirst} titlesecond={titlesecond} />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export const BottomBarSubmit = ({ titlefirst, titlesecond, className }) => {
  return (
    <div className={STYLE_BOTTOM_BAR}>
      <TwoButton
        titlefirst={titlefirst}
        titlesecond={titlesecond}
        className={className}
      />
    </div>
  );
};

export const BottomBarAddress = ({
  title,
  setTab,
  refetch,
  isStar,
  setIsStar,
  onClick,
  isAvailable,
}) => {
  const { language } = React.useContext(ContextLanguage);
  const { user } = useSelector((state) => state.auth);
  const [isConfirm, setIsConfirm] = React.useState(false);
  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");

  const isMobile = useIsMobile();
  const { cart } = React.useContext(ContextCart);

  const [isPrimary, setIsPrimary] = React.useState(false);

  const selectedLocation = StoreSelectedLocation(
    (state) => state.selectedLocation
  );
  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  const setAddress = SystemStoreBasketAddress((state) => state.setAddress);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const isFav = isStar || selectedLocation?._id

  const isFav = isStar;

  React.useEffect(() => {
    if (selectedLocation?._id) {
      setDescription(selectedLocation?.detail);
      setName(selectedLocation?.title);
      setIsPrimary(selectedLocation?.primary);
    } else {
      setDescription("");
      setName("");
      setIsPrimary("");
    }
  }, [selectedLocation?._id]);

  const textAreaRef = React.useRef();

  useAutosizeTextArea(
    textAreaRef.current,
    description,
    isMobile ? 88 : 64,
    selectedLocation?.isAvailable
  );

  // useAutosizeTextArea(textAreaRef2.current, name, 56);

  if (selectedLocation?.name === "Loading...") {
    return <div></div>;
  }

  return (
    <div className="bg-white  mt-auto mb-10 md:mb-0">
      {selectedLocation?.isAvailable ? (
        <div className={`${STYLE_BOTTOM_BAR} ${STYLE_MAX_WIDTH_DESKTOP} `}>
          {isFav && (
            <div
              className={`bg-white  border border-laudry-stroke rounded-lg w-full h-14  flex justify-center items-center mt-3 md:mt-4 mb-3 md:mb-4 `}
            >
              <input
                className={` bg-transparent w-full  px-3 h-12 border-b-transparent focus:outline-none text-laundry-gray-100 font-normal ${
                  language === "TH"
                    ? " font-NotoSansThai text-13-th md:text-base-th  "
                    : " font-Poppins text-13  md:text-base  "
                }`}
                placeholder={TEXT_PLACEHOLDER_ADDRESS_NAME[language]}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>
          )}
          {selectedLocation?.isAvailable && (
            <AddressMarker setIsStar={setIsStar} isStar={isFav} />
          )}

          <textarea
            maxLength={MAX_TEXT_LENGTH}
            style={{
              overflow: "hidden",
              resize: "none",
              display: isFav ? "block" : "none",
            }}
            ref={textAreaRef}
            value={description}
            className={` ${
              language === "TH"
                ? " font-NotoSansThai text-13-th md:text-base-th "
                : " font-Poppins text-13 md:text-base "
            }  w-full  border border-laudry-stroke rounded-md text-laundry-gray-100 font-normal h-12 p-p_14 md:py-2 px-3   focus:outline-none  leading-5 md:leading-6 `}
            placeholder={TEXT_PLACEHOLDER_ADDRESS_DETAIL[language]}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />
          {isFav && (
            <div className={`flex justify-between my-4 md:mt-3 md:mb-5 `}>
              <div
                className={
                  ` ${
                    language === "TH"
                      ? " text-sm-th md:text-base-th "
                      : " text-sm md:text-base "
                  } font-semibold my-auto ` +
                  `${
                    isPrimary
                      ? " text-laundry-gray-100 "
                      : "  text-laundry-gray-30 "
                  }`
                }
              >
                {TEXT_PRIMARY[language]}
              </div>
              <SwitchCeles setValue={setIsPrimary} value={isPrimary} />
            </div>
          )}

          {isConfirm ? (
            <BlueButton
              classNameBottomBar={STYLE_HEIGHT_BAR}
              title={title}
              onClick={() => {
                setIsConfirm(true);
              }}
            />
          ) : (
            <React.Fragment>
              {isFav ? (
                <div className={STYLE_TWOBUTTON_ADDRESS}>
                  <div
                    style={{
                      height: isMobile ? "50px" : "100%",
                    }}
                    onClick={() => {
                      setTab(STATE_CONSTANTS_ADDRESS.SELECT);
                    }}
                    className={`cursor-pointer ${STYLE_BORDER_BLUE_ADDRESS(
                      language
                    )}`}
                  >
                    {TEXT_CANCEL[language]}
                  </div>
                  <DeclareState
                    name="confirm-state"
                    initalState={false}
                    body={({ state, setState }) => {
                      return (
                        <div
                          style={{
                            height: isMobile ? "50px" : "100%",
                          }}
                          onClick={() => {
                            AddressCreateMyLocation(
                              name,
                              description,
                              selectedLocation,
                              user,
                              setTab,
                              refetch,
                              isPrimary,
                              dispatch,
                              setSelectedLocation,
                              setState,
                              state,
                              navigate,
                              setAddress
                            );
                          }}
                          className={`${
                            state
                              ? " bg-laundry-bglight "
                              : " bg-laundry-primary-blue "
                          }  ${
                            language === "TH"
                              ? " text-sm-th xl:text-base-th "
                              : " text-sm xl:text-base "
                          } cursor-pointer w-full   rounded-lg text-white font-semibold   hover:bg-laundry-gray-80 hover:order-blue   focus:outline-none  flex justify-center items-center  `}
                        >
                          {TEXT_CONFIRM[language]}
                        </div>
                      );
                    }}
                  />
                </div>
              ) : (
                <React.Fragment>
                  {selectedLocation?.isAvailable && (
                    <BlueButton
                      classNameBottomBar={STYLE_HEIGHT_BAR}
                      onClick={() => {
                        sessionStorage.removeItem("addressDetail");
                        setAddress(selectedLocation);
                        setSelectedLocation(false);

                        if (cart?.length > 0) {
                          navigate("/Basket");
                        } else {
                          navigate("/OurServices");
                        }
                      }}
                      title={TEXT_CONFIRM[language]}
                    />
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
      ) : (
        <div className={`${STYLE_BOTTOM_BAR}  ${STYLE_MAX_WIDTH_DESKTOP} `}>
          <AddressMarker />
          <BlueButton title={TEXT_SEARCH_AGAIN[language]} onClick={onClick} />
        </div>
      )}
    </div>
  );
};

export const BottomBarScroll = ({
  title,
  onClick,
  Calculate,
  icon,
  disable,
  onClickDisable,
  Submit,
  titlefirst,
  titlesecond,
  onSubmit,
  bottompadding,
  classNameBottomBar = "",
  refScreen,
}) => {
  const { language } = useContext(ContextLanguage);
  return (
    <div
      style={{
        width: refScreen?.current?.clientWidth,
      }}
      className={`mx-auto`}
    >
      <div className={` md:h-full pt-4 md:py-8 bg-white mx-auto `}>
        {Calculate ? <Total /> : ""}
        {disable ? (
          <DisableButton
            title={title}
            onClick={onClickDisable}
            icon={icon}
            className={`${STYLE_BUTTON_BAR_DISABLE(language)}`}
          />
        ) : (
          <BlueButton
            title={title}
            onClick={onClick}
            onSubmit={onSubmit}
            icon={icon}
            className={`${STYLE_BUTTON_BAR_BLUE(language)} `}
          />
        )}
        {Submit ? (
          <TwoButton titlefirst={titlefirst} titlesecond={titlesecond} />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
